'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:AboutCtrl
 * @description
 * # AboutCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('AboutCtrl', ['$scope', '$http', 'moment', function ($scope, $http, moment) {
    $scope.awesomeThings = [
      'HTML5 Boilerplate',
      'AngularJS',
      'Karma'
    ];

    //var baseUrl = 'http://api.gadwalltechnologies.co.uk';
    $scope.baseUrl = 'http://127.0.1.1:8080';
    $scope.apiVersion = '/v1';
    $scope.customersUrl = '/customers';
    $scope.time = new Date();
    var url = 'http://127.0.1.1:8080/v1/customers';
    //var url2 = '$scope.baseUrl+$scope.apiVersion+$scope.customersUrl';

    $http.get(url)
        .then(function (response) {
          $scope.customers = response.data;

          angular.forEach($scope.customers, function(value){
            value.dateOfBirth = moment(value.dateOfBirth).format('DD MMMM, YYYY');
          });
        });
  }]);
